import React from 'react'
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const CommonTooltip = (props) => {
    const { id, style, place,float } = props;
    return (
        <>
            <Tooltip 
                id={id} 
                style={style}
                place={place}
                float={float}
            />
        </>
    )
}

export default CommonTooltip